"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduledPulseEventInputSchema = exports.IRRIGATION_SCHEDULER_PUBLISH_ERROR = exports.IRRIGATION_SCHEDULER_ERROR = exports.scheduledEventOutputSchema = exports.scheduledEventInputSchema = exports.fertigationScheduleSchema = exports.EControlProvider = exports.EIrrigationVendorName = exports.fertigationFlowRateUnitSchema = exports.fertigationTypeSchema = exports.zoneStopStatusSchema = exports.eventStatusSchema = void 0;
const app_platform_values_helpers_and_types_1 = require("@semios/app-platform-values-helpers-and-types");
const zod_1 = __importDefault(require("zod"));
exports.eventStatusSchema = zod_1.default.enum([
    'DELETED',
    'DRAFT',
    'PUBLISHED',
    'STOP_PENDING',
    'STOPPED_IN_PROGRESS',
    'ZONE_STOPPED',
    'DELETION_AWAITING_CONTROL_PROVIDER_CONFIRMATION',
]);
exports.zoneStopStatusSchema = zod_1.default.enum(['STOPPED', 'RESUMED', 'STOP_PENDING']);
exports.fertigationTypeSchema = zod_1.default.enum(['duration', 'volume', 'proportional']);
exports.fertigationFlowRateUnitSchema = zod_1.default.enum(['gal/min', 'l/h']);
var EIrrigationVendorName;
(function (EIrrigationVendorName) {
    EIrrigationVendorName["wiseconn"] = "wiseconn";
    EIrrigationVendorName["altrac"] = "altrac";
    EIrrigationVendorName["nelson"] = "nelson";
})(EIrrigationVendorName || (exports.EIrrigationVendorName = EIrrigationVendorName = {}));
var EControlProvider;
(function (EControlProvider) {
    EControlProvider["wiseconn"] = "wiseconn";
    EControlProvider["altrac"] = "altrac";
})(EControlProvider || (exports.EControlProvider = EControlProvider = {}));
const fertigationScheduleObjectSchema = zod_1.default.object({
    fertigationType: exports.fertigationTypeSchema,
    injectorId: zod_1.default.number(), // tank id
    fertilizerId: zod_1.default.number(),
    fertigationStartDelay: zod_1.default.number().int().nonnegative(), // minutes
    duration: zod_1.default.number().int().positive().optional(), // minutes
    fertigationStartTime: zod_1.default.string().optional(),
    fertigationEndTime: zod_1.default.string().optional(),
    volume: zod_1.default.number().positive().optional(), // gallons
    waterVolume: zod_1.default.number().positive().optional(), // gallons
    fertilizerVolume: zod_1.default.number().positive().optional(), // gallons
});
const requiredFieldsByFertigationType = {
    duration: ['duration'],
    proportional: ['duration', 'waterVolume', 'fertilizerVolume'],
    volume: ['volume'],
};
exports.fertigationScheduleSchema = fertigationScheduleObjectSchema.superRefine((schedule, ctx) => {
    const requiredFields = requiredFieldsByFertigationType[schedule.fertigationType];
    requiredFields.forEach((field) => {
        if (schedule[field] === undefined) {
            ctx.addIssue({
                code: zod_1.default.ZodIssueCode.custom,
                path: [field],
                message: `${field} is required for ${schedule.fertigationType} fertigation`,
            });
        }
    });
});
exports.scheduledEventInputSchema = zod_1.default.object({
    dateFrom: zod_1.default.string().datetime(),
    dateTo: zod_1.default.string().datetime(),
    emitterType: zod_1.default.enum(app_platform_values_helpers_and_types_1.EMITTER_TYPES),
    irrigationZoneEmitterId: zod_1.default.string(),
    irrigationZoneId: zod_1.default.number(),
    eventId: zod_1.default.number(),
    fertigationSchedules: zod_1.default.array(exports.fertigationScheduleSchema).optional(),
});
exports.scheduledEventOutputSchema = exports.scheduledEventInputSchema.extend({
    status: exports.eventStatusSchema,
});
var IRRIGATION_SCHEDULER_ERROR;
(function (IRRIGATION_SCHEDULER_ERROR) {
    IRRIGATION_SCHEDULER_ERROR["OVERLAPPING_EVENT"] = "OVERLAPPING_EVENT";
    IRRIGATION_SCHEDULER_ERROR["FERTIGATION_SCHEDULE_OVERLAP"] = "FERTIGATION_SCHEDULE_OVERLAP";
    IRRIGATION_SCHEDULER_ERROR["FERTIGATION_SCHEDULE_OUT_OF_RANGE"] = "FERTIGATION_SCHEDULE_OUT_OF_RANGE";
    IRRIGATION_SCHEDULER_ERROR["FERTIGATION_INJECTOR_FLOW_RATE_UNKNOWN"] = "FERTIGATION_INJECTOR_FLOW_RATE_UNKNOWN";
})(IRRIGATION_SCHEDULER_ERROR || (exports.IRRIGATION_SCHEDULER_ERROR = IRRIGATION_SCHEDULER_ERROR = {}));
var IRRIGATION_SCHEDULER_PUBLISH_ERROR;
(function (IRRIGATION_SCHEDULER_PUBLISH_ERROR) {
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_AWAITING_DELETION"] = "ERROR_PUBLISH_AWAITING_DELETION";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_DEVICE_NOT_READY"] = "ERROR_PUBLISH_DEVICE_NOT_READY";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_FERTIGATION_OVERLAP"] = "ERROR_PUBLISH_FERTIGATION_OVERLAP";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_FERTIGATION_NOT_IN_RANGE"] = "ERROR_PUBLISH_FERTIGATION_NOT_IN_RANGE";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_FERTIGATION_FLOW_RATE_UNIT_UNSUPPORTED"] = "ERROR_PUBLISH_FERTIGATION_FLOW_RATE_UNIT_UNSUPPORTED";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_OVERLAPPING_IRRIGATION_IN_THE_SAME_ZONE"] = "ERROR_PUBLISH_OVERLAPPING_IRRIGATION_IN_THE_SAME_ZONE";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_TANK_FERTILIZER_INCOMPATIBLE"] = "ERROR_PUBLISH_TANK_FERTILIZER_INCOMPATIBLE";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH_TANK_ASSOCIATE_WITH_ANOTHER_PUMP"] = "ERROR_PUBLISH_TANK_ASSOCIATE_WITH_ANOTHER_PUMP";
    IRRIGATION_SCHEDULER_PUBLISH_ERROR["ERROR_PUBLISH"] = "ERROR_PUBLISH";
})(IRRIGATION_SCHEDULER_PUBLISH_ERROR || (exports.IRRIGATION_SCHEDULER_PUBLISH_ERROR = IRRIGATION_SCHEDULER_PUBLISH_ERROR = {}));
// type definitions for pulse irrigation
exports.scheduledPulseEventInputSchema = zod_1.default.object({
    dateFrom: zod_1.default.string().datetime(),
    dateTo: zod_1.default.string().datetime(),
    emitterType: zod_1.default.enum(app_platform_values_helpers_and_types_1.EMITTER_TYPES),
    irrigationZoneId: zod_1.default.number(),
    pulseEventId: zod_1.default.number(),
    onDuration: zod_1.default.number(),
    offDuration: zod_1.default.number(),
    numberOfCycles: zod_1.default.number(),
});
//# sourceMappingURL=irrigationScheduler.js.map